import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useGlobal } from '../../../contexts/GlobalContext'
import { Input } from '../InputBox'
import { CheckIcon } from '../SvgIcons'
import {
  FilterContainer,
  InputWrapper,
  DropDownContainer,
  DropDownItem
} from './styles'

const PIXELS_TO_SCROLL = 20;

export const CollectionFilter = (props) => {
  const {
    handleChangeFilterValues,
    filterValues
  } = props

  const { invokeServer } = useGlobal()

  const [searchValue, setSearchValue] = useState('')
  const [collectionList, setCollectionList] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadMore, setIsLoadMore] = useState(false)
  const [paginationProps, setPaginationProps] = useState({
    page_size: 10,
    current_page: 1
  })

  let timeout = null
  const dropDownRef = useRef()

  const onChangeSearch = (e) => {
    clearTimeout(timeout)

    timeout = setTimeout(function () {
      setSearchValue(e.target.value)
    }, 750)
  }

  const handleChangeAddress = (address) => {
    if (filterValues?.address === address) {
      handleChangeFilterValues('address', null)
      return
    }
    handleChangeFilterValues('address', address)
  }

  const getCollectionList = (page, page_size, newFetch = false) => {
    if (newFetch) setIsLoading(true)
    else setIsLoadMore(true)
    let params = filterValues.address
      ? `/api/collection/search?key=${searchValue}&page=${page}&page_size=${page_size}&addresses=${filterValues.address}`
      : `/api/collection/search?key=${searchValue}&page=${page}&page_size=${page_size}`
    invokeServer('get', params)
      .then(res => {
        if (res.data.result === 1) {
          if (newFetch) setCollectionList(res.data.items)
          else setCollectionList([...collectionList, ...res.data.items])
          console.log(res.data.items)
          setPaginationProps(res.data.pagination)
        } else {
          console.log(res.data.msg)
        }
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
      })
      .catch(err => {
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
        console.log(err)
      })
  }

  useEffect(() => {
    getCollectionList(1, paginationProps.page_size, true)
  }, [searchValue])

  const handleScroll = useCallback(() => {
    if (isLoadMore) return;

    const innerHeightScrolltop =
    dropDownRef?.current.offsetHeight +
    dropDownRef?.current.scrollTop +
      PIXELS_TO_SCROLL;
      if (dropDownRef?.current.scrollHeight < innerHeightScrolltop && paginationProps.current_page <= paginationProps.total_pages) {
        getCollectionList(paginationProps.current_page + 1, paginationProps.page_size)
      }
  }, [isLoadMore, paginationProps])

  useEffect(() => {
    dropDownRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      dropDownRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll])

  return (
    <FilterContainer>
      <InputWrapper>
        <Input
          // value={searchValue}
          onChange={onChangeSearch}
          placeholder='Search'
        />
      </InputWrapper>
      <DropDownContainer ref={dropDownRef}>
        {collectionList?.length > 0 && collectionList.map((collection, i) => (
          <DropDownItem
            key={i}
            onClick={() => handleChangeAddress(collection.contractAddress)}
          >
            <div>
              {filterValues?.address === collection.contractAddress ? (
                <CheckIcon />
              ) : (
                <img src={collection?.bannerURI} alt={collection?.name} />
              )}
            </div>
            <span>{collection?.name}</span>
          </DropDownItem>
        ))}
      </DropDownContainer>
    </FilterContainer>
  )
}
